import { API_REFERENCE } from '../utilities/constant_api';
const cancelOrderConfirmClass = '.cancel-order_confirm';
const cancelOrderReasonId = '#cancelOrderReason';
const cancelOrderRelocateURL = `${ACC.config.encodedContextPath}${API_REFERENCE.orderHistory.cancelOrderItem}`;

const cancelOrderReasonSelect = $(cancelOrderReasonId);
const cancelOrderReasonError = $('.cancel-order-reason-error');
const cancelOrderForm = $('#cancel-order');
const cancelOrderFunction = {
  checkForReturnReason(e) {
    e.preventDefault();
    if (
      cancelOrderReasonSelect.val() === '' ||
      cancelOrderReasonSelect.val() === null
    ) {
      cancelOrderReasonError.removeClass('hidden');
      cancelOrderReasonSelect.addClass('error-msg-textbox');
    } else {
      cancelOrderReasonError.addClass('hidden');
      cancelOrderReasonSelect.removeClass('error-msg-textbox');
      if ($(this).hasClass('cancel-order_confirm')) {
		$(this).css('pointer-events', 'none');
        cancelOrderForm.submit();
      }
    }
  },
  openCancelOrder() {
    const cancelOrderCode = $(this).attr('data-cancel-order-code');
    window.location.href = `${cancelOrderRelocateURL}${cancelOrderCode}`;
    return false;
  },
  init() {
    $(cancelOrderConfirmClass).on('click', this.checkForReturnReason);
    cancelOrderReasonSelect.on('selectmenuchange', this.checkForReturnReason);
    $(document).on(
      'click',
      '.orderCancelButton, .modify-order-cancel-order',
      this.openCancelOrder
    );
    $(cancelOrderReasonId).selectmenu();
  }
};
cancelOrderFunction.init();
export default cancelOrderFunction;
